"use client"

import { ChevronRight } from "@untitledui/icons"
import { useState } from "react"

import type { BriefFaq } from "@/types"

interface FaqAccordionProps {
  faqs: BriefFaq[]
}

export function FaqAccordion({ faqs }: FaqAccordionProps) {
  const [openItems, setOpenItems] = useState<Set<number>>(new Set())

  if (faqs.length === 0) {
    return null
  }

  const toggleItem = (id: number) => {
    setOpenItems((prev) => {
      const next = new Set(prev)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return next
    })
  }

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-primary text-lg font-semibold">FAQ</h3>
      <div className="divide-secondary border-secondary flex flex-col divide-y overflow-hidden rounded-lg border">
        {faqs.map((briefFaq) => {
          const isOpen = openItems.has(briefFaq.id)
          return (
            <div key={briefFaq.id} className="flex flex-col">
              <button
                type="button"
                className="hover:bg-primary_hover flex items-center justify-between gap-4 p-4 text-left transition-colors"
                onClick={() => toggleItem(briefFaq.id)}
                aria-expanded={isOpen}
              >
                <span className="text-primary font-medium">
                  {briefFaq.faq.question}
                </span>
                <ChevronRight
                  className={`text-tertiary size-5 shrink-0 transition-transform ${
                    isOpen ? "rotate-90" : ""
                  }`}
                />
              </button>
              {isOpen && (
                <div className="px-4 pb-4">
                  <p className="text-secondary text-sm whitespace-pre-wrap">
                    {briefFaq.faq.answer}
                  </p>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
